export default __webpack_public_path__ + "static/media/curbside_gg.f4797ba7.svg";